module.exports = __webpack_public_path__ + "static/media/profile.370ddc12.svg";